import { qk, STALE_TIME } from "@secretaa/sdk-react";
import { Card, EmptyState } from "@secretaa/ui";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { api } from "../../app/api.ts";
import { useCurrentWorkspace } from "../../app/session.ts";
import { errorMessage } from "../../shared/errors.ts";
import { FormError, PageHeader } from "../../shared/form.tsx";

// Trang chủ workspace (P0): dự án gần đây + hoạt động gần đây — BFF gom song song (W.3). Không render chỗ trống giả
// cho « Hỏi SecretAA » / « Việc cần chú ý ».
export function OverviewPage() {
  const { t, i18n } = useTranslation();
  const cur = useCurrentWorkspace()!;
  const home = useQuery({ queryKey: qk.recentActivity(cur.tenant), queryFn: () => api.home(cur.workspaceId), staleTime: STALE_TIME.auditFeed });
  const members = useQuery({ queryKey: qk.members(cur.tenant), queryFn: () => api.members.list(cur.workspaceId), staleTime: STALE_TIME.workspaceMeta });
  const nameOf = (id: string) => members.data?.find((m) => m.userId === id)?.displayName ?? "—";
  const fmt = new Intl.DateTimeFormat(i18n.language, { dateStyle: "medium", timeStyle: "short" });
  if (home.isPending) return <p>{t("app.loading")}</p>;
  if (home.isError) return <FormError message={errorMessage(t, home.error)} />;
  const { recentProjects, recentActivity } = home.data;
  return (
    <>
      <PageHeader title={home.data.workspace.workspace.name} />
      <div className="grid gap-6 lg:grid-cols-2">
        <Card>
          <h2 className="mb-3 font-semibold">{t("home.recentProjects")}</h2>
          {!recentProjects.ok ? (
            <p className="text-sm text-(--saa-fg-muted)">{t("home.sectionUnavailable")}</p>
          ) : recentProjects.data?.length ? (
            <ul className="flex flex-col gap-1">
              {recentProjects.data.map((p) => (
                <li key={p.id}>
                  <Link className="flex justify-between rounded-md px-2 py-1 hover:bg-(--saa-muted)" to={`/w/${cur.workspaceId}/projects/${p.id}`}>
                    <span>{p.name}</span>
                    <span className="font-mono text-xs text-(--saa-fg-muted)">{p.key}</span>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState title={t("home.noProjects")} />
          )}
        </Card>
        <Card>
          <h2 className="mb-3 font-semibold">{t("home.recentActivity")}</h2>
          {!recentActivity.ok ? (
            <p className="text-sm text-(--saa-fg-muted)">{t("home.sectionUnavailable")}</p>
          ) : recentActivity.data?.length ? (
            <ul className="flex flex-col gap-2 text-sm">
              {recentActivity.data.map((e) => (
                <li key={e.id} className="flex justify-between gap-2">
                  <span>
                    <strong>{nameOf(e.actorId)}</strong> {t(`activity.${e.eventType}`, { defaultValue: e.eventType, action: t(`access.actions.${e.action ?? "unknown"}`, { defaultValue: t("access.actions.unknown") }) })}
                  </span>
                  <time className="shrink-0 text-(--saa-fg-muted)" dateTime={e.createdAt}>
                    {fmt.format(new Date(e.createdAt))}
                  </time>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState title={t("home.noActivity")} />
          )}
        </Card>
      </div>
    </>
  );
}
